import React from "react";
import { CBadge } from "@coreui/react";
import { FormattedMessage } from "react-intl";

export default function StatusBadge({
  status,
  isGy25FinalExam,
  title,
  isTestModule = false,
}) {
  const statusMessage = (
    <FormattedMessage
      id={isGy25FinalExam ? status + "_gy25FinalExam" : status}
    />
  );

  const colors = {
    InProgress: "warning",
    NotStarted: "secondary",
    Done: "success",
    Completed: "success",
  };

  const finalExamColors = {
    InProgress: "warning",
    NotStarted: "secondary",
    Done: "danger",
    Completed: "success",
  };

  const values = {
    NotStarted: "0",
    InProgress: "1",
    Done: "2",
    Completed: "3",
  };

  return (
    <CBadge
      className="badge-pill d-inline-flex align-items-center me-1"
      shape="pill"
      color={isGy25FinalExam ? finalExamColors[status] : colors[status]}
      value={values[status]}
      title={title}
    >
      <span className="fw-normal px-2">{statusMessage}</span>
      {isTestModule && (
        <img src="img/BrainIcon.svg" alt="Test module" className="brain_icon" />
      )}
    </CBadge>
  );
}
